import React from "react";
import { PetType } from "../../types";

export const PetInfo = ({
  name,
  petType,
}: {
  name: string;
  petType: PetType;
}) => {
  return (
    <div className="pet-info">
      <div>{name}</div>
      <div>{petType}</div>
    </div>
  );
};
